/* Options:
Date: 2024-12-06 08:08:17
Version: 6.40
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44349

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export enum FileType
{
    Iif = 1,
    ExpenseManager = 2,
}

export class ReferenceType
{
    public id: string;
    public value: string;

    public constructor(init?: Partial<ReferenceType>) { (Object as any).assign(this, init); }
}

export class EmailAddress
{
    public id: string;
    public address: string;
    public default: boolean;
    public tag: string;

    public constructor(init?: Partial<EmailAddress>) { (Object as any).assign(this, init); }
}

export enum GlobalTaxCalculationEnum
{
    TaxInclusive = 'TaxInclusive',
    TaxExcluded = 'TaxExcluded',
    NotApplicable = 'NotApplicable',
}

export class MetaData
{
    public createdBy: ReferenceType;
    public createTime?: string;
    public lastModifiedBy: ReferenceType;
    public lastUpdatedTime?: string;
    public lastChangedInQuickbooks?: string;
    public synchronized?: boolean;

    public constructor(init?: Partial<MetaData>) { (Object as any).assign(this, init); }
}

export class PhysicalAddress
{
    public id: string;
    public line1: string;
    public line2: string;
    public line3: string;
    public line4: string;
    public line5: string;
    public city: string;
    public country: string;
    public countryCode: string;
    public county: string;
    public countrySubDivisionCode: string;
    public postalCode: string;
    public postalCodeSuffix: string;
    public lat: string;
    public long: string;
    public tag: string;
    public note: string;

    public constructor(init?: Partial<PhysicalAddress>) { (Object as any).assign(this, init); }
}

export enum EntityStatusEnum
{
    Deleted = 'Deleted',
    Voided = 'Voided',
    Draft = 'Draft',
    Pending = 'Pending',
    InTransit = 'InTransit',
    Synchronized = 'Synchronized',
    SyncError = 'SyncError',
}

export enum TaxReviewStatusEnum
{
    NON_AST_TAX = 'NON_AST_TAX',
    AST_TAX_OVERRIDE = 'AST_TAX_OVERRIDE',
}

export class LinkedTransaction
{
    public id: string;
    public type: string;
    public lineId: string;

    public constructor(init?: Partial<LinkedTransaction>) { (Object as any).assign(this, init); }
}

export enum LineDetailTypeEnum
{
    PaymentLineDetail = 'PaymentLineDetail',
    DiscountLineDetail = 'DiscountLineDetail',
    TaxLineDetail = 'TaxLineDetail',
    SalesItemLineDetail = 'SalesItemLineDetail',
    ItemBasedExpenseLineDetail = 'ItemBasedExpenseLineDetail',
    AccountBasedExpenseLineDetail = 'AccountBasedExpenseLineDetail',
    DepositLineDetail = 'DepositLineDetail',
    PurchaseOrderItemLineDetail = 'PurchaseOrderItemLineDetail',
    ItemReceiptLineDetail = 'ItemReceiptLineDetail',
    JournalEntryLineDetail = 'JournalEntryLineDetail',
    GroupLineDetail = 'GroupLineDetail',
    DescriptionOnly = 'DescriptionOnly',
    SubTotalLineDetail = 'SubTotalLineDetail',
    SalesOrderItemLineDetail = 'SalesOrderItemLineDetail',
    TDSLineDetail = 'TDSLineDetail',
    ReimburseLineDetail = 'ReimburseLineDetail',
    ItemAdjustmentLineDetail = 'ItemAdjustmentLineDetail',
}

export class TaxDistribution
{
    public id: string;
    public lineNum: string;
    public description: string;
    public amount?: number;
    public received?: number;
    public linkedTransactions: LinkedTransaction[];
    public detailType?: LineDetailTypeEnum;
    public percentBased?: boolean;
    public taxPercent?: number;
    public netAmountTaxable?: number;
    public overrideDeltaAmount?: number;
    public serviceDate: string;
    public taxRate: ReferenceType;
    public taxInclusiveAmount?: number;

    public constructor(init?: Partial<TaxDistribution>) { (Object as any).assign(this, init); }
}

export class TaxDetails
{
    public defaultTaxCode: ReferenceType;
    public transactionTaxCode: ReferenceType;
    public totalTax?: number;
    public taxReviewStatus?: TaxReviewStatusEnum;
    public distributions: TaxDistribution[];

    public constructor(init?: Partial<TaxDetails>) { (Object as any).assign(this, init); }
}

export enum BillableStatusEnum
{
    Billable = 'Billable',
    NotBillable = 'NotBillable',
    HasBeenBilled = 'HasBeenBilled',
}

export class MarkupInformation
{
    public percentBased?: boolean;
    public value?: number;
    public percent?: number;
    public priceLevel: ReferenceType;
    public markUpIncomeAccount: ReferenceType;

    public constructor(init?: Partial<MarkupInformation>) { (Object as any).assign(this, init); }
}

export class ExpenseDistribution
{
    public id: string;
    public lineNum: string;
    public description: string;
    public amount?: number;
    public received?: number;
    public linkedTransactions: LinkedTransaction[];
    public detailType?: LineDetailTypeEnum;
    public customer: ReferenceType;
    public class: ReferenceType;
    public account: ReferenceType;
    public billableStatus?: BillableStatusEnum;
    public markupInformation: MarkupInformation;
    public taxAmount?: number;
    public taxCodeRef: ReferenceType;
    public taxInclusiveAmount?: number;

    public constructor(init?: Partial<ExpenseDistribution>) { (Object as any).assign(this, init); }
}

export class Bill
{
    public account: ReferenceType;
    public balance?: number;
    public billEmail: EmailAddress;
    public currency: ReferenceType;
    public department: ReferenceType;
    public docNumber: string;
    public dueDate?: string;
    public exchangeRate?: number;
    public globalTaxCalculation?: GlobalTaxCalculationEnum;
    public homeBalance?: number;
    public id: string;
    public includeInAnnualTPAR?: boolean;
    public memo: string;
    public metaData: MetaData;
    public payer: ReferenceType;
    public privateNote: string;
    public remitToAddress: PhysicalAddress;
    public replyEmail: EmailAddress;
    public salesTerm: ReferenceType;
    public shippingAddress: PhysicalAddress;
    public sparse?: boolean;
    public status?: EntityStatusEnum;
    public syncToken: string;
    public taxFormNumber: string;
    public taxFormType: string;
    public totalAmount?: number;
    public transactionDate?: string;
    public transactionSource: string;
    public transactionStatus: string;
    public transactionTaxDetails: TaxDetails;
    public vendor: ReferenceType;
    public distributionAmount?: number;
    public distributionTax?: number;
    public distributionTotal?: number;
    public distributions: ExpenseDistribution[];
    public linkedTransactions: LinkedTransaction[];

    public constructor(init?: Partial<Bill>) { (Object as any).assign(this, init); }
}

export enum PaymentTypeEnum
{
    Cash = 'Cash',
    Check = 'Check',
    CreditCard = 'CreditCard',
    Expense = 'Expense',
    Other = 'Other',
}

export enum PrintStatusEnum
{
    NotSet = 'NotSet',
    NeedToPrint = 'NeedToPrint',
    PrintComplete = 'PrintComplete',
}

export class Expense
{
    public account: ReferenceType;
    public credit?: boolean;
    public currency: ReferenceType;
    public department: ReferenceType;
    public docNumber: string;
    public vendor: ReferenceType;
    public exchangeRate?: number;
    public globalTaxCalculation?: GlobalTaxCalculationEnum;
    public id: string;
    public includeInAnnualTPAR?: boolean;
    public memo: string;
    public metaData: MetaData;
    public paymentMethod: ReferenceType;
    public paymentNumber: string;
    public paymentType?: PaymentTypeEnum;
    public printStatus?: PrintStatusEnum;
    public privateNote: string;
    public remitToAddress: PhysicalAddress;
    public sparse?: boolean;
    public status?: EntityStatusEnum;
    public syncToken: string;
    public taxFormNumber: string;
    public taxFormType: string;
    public totalAmount?: number;
    public transactionId: string;
    public transactionNumber: string;
    public transactionDate?: string;
    public transactionSource: string;
    public transactionStatus: string;
    public transactionTaxDetails: TaxDetails;
    public distributionAmount?: number;
    public distributionTax?: number;
    public distributionTotal?: number;
    public distributions: ExpenseDistribution[];
    public linkedTransactions: LinkedTransaction[];

    public constructor(init?: Partial<Expense>) { (Object as any).assign(this, init); }
}

export enum DeliveryTypeEnum
{
    Email = 'Email',
    Tradeshift = 'Tradeshift',
}

export enum DeliveryErrorTypeEnum
{
    MissingInfo = 'MissingInfo',
    Undeliverable = 'Undeliverable',
    DeliveryServerDown = 'DeliveryServerDown',
    BouncedEmail = 'BouncedEmail',
}

export class DeliveryInformation
{
    public deliveryType?: DeliveryTypeEnum;
    public deliveryTime?: string;
    public deliveryErrorType?: DeliveryErrorTypeEnum;

    public constructor(init?: Partial<DeliveryInformation>) { (Object as any).assign(this, init); }
}

export enum EmailStatusEnum
{
    NotSet = 'NotSet',
    NeedToSend = 'NeedToSend',
    EmailSent = 'EmailSent',
}

export enum ItemChoiceType
{
    PriceLevelRef = 'PriceLevelRef',
    RatePercent = 'RatePercent',
    UnitPrice = 'UnitPrice',
}

export class SalesItemDistribution
{
    public id: string;
    public lineNum: string;
    public description: string;
    public amount?: number;
    public received?: number;
    public linkedTransactions: LinkedTransaction[];
    public detailType?: LineDetailTypeEnum;
    public discountAmount?: number;
    public discountRate?: number;
    public inventorySite: ReferenceType;
    public itemAccount: ReferenceType;
    public itemElementName?: ItemChoiceType;
    public item: ReferenceType;
    public quantity?: number;
    public serviceDate?: string;
    public taxClassification: ReferenceType;
    public uom: ReferenceType;
    public class: ReferenceType;
    public markupInformation: MarkupInformation;
    public taxCodeRef: ReferenceType;
    public taxAmount?: number;
    public taxInclusiveAmount?: number;

    public constructor(init?: Partial<SalesItemDistribution>) { (Object as any).assign(this, init); }
}

export class SalesReceipt
{
    public applyTaxAfterDiscount?: boolean;
    public arAccount: ReferenceType;
    public autoDocNumber?: boolean;
    public balance?: number;
    public billEmail: EmailAddress;
    public billEmailBcc: EmailAddress;
    public billEmailCc: EmailAddress;
    public billingAddress: PhysicalAddress;
    public class: ReferenceType;
    public currency: ReferenceType;
    public customerMemo: string;
    public customer: ReferenceType;
    public department: ReferenceType;
    public depositToAccount: ReferenceType;
    public deliveryInformation: DeliveryInformation;
    public discountAmount?: number;
    public discountRate?: number;
    public docNumber: string;
    public dueDate?: string;
    public emailStatus?: EmailStatusEnum;
    public exchangeRate?: number;
    public financeCharge?: boolean;
    public fob: string;
    public freeFormAddress?: boolean;
    public globalTaxCalculation?: GlobalTaxCalculationEnum;
    public govtTxnRefIdentifier: string;
    public homeBalance?: number;
    public homeTotalAmount?: number;
    public id: string;
    public metaData: MetaData;
    public paymentMethod: ReferenceType;
    public paymentReferenceNumber: string;
    public paymentType?: PaymentTypeEnum;
    public purchaseOrderNumber: string;
    public printStatus?: PrintStatusEnum;
    public privateNote: string;
    public remitTo: ReferenceType;
    public sparse?: boolean;
    public status?: EntityStatusEnum;
    public salesRepresentative: ReferenceType;
    public salesTerm: ReferenceType;
    public shippingAddress: PhysicalAddress;
    public shippingMethod: ReferenceType;
    public syncToken: string;
    public taxExemption: ReferenceType;
    public template: ReferenceType;
    public trackingNumber: string;
    public taxFormNumber: string;
    public taxFormType: string;
    public totalAmount?: number;
    public transactionDate?: string;
    public transactionSource: string;
    public transactionStatus: string;
    public transactionTaxDetails: TaxDetails;
    public distributionAmount?: number;
    public distributionTax?: number;
    public distributionTotal?: number;
    public distributions: SalesItemDistribution[];
    public linkedTransactions: LinkedTransaction[];

    public constructor(init?: Partial<SalesReceipt>) { (Object as any).assign(this, init); }
}

export enum TaxApplicableOnEnum
{
    Purchase = 'Purchase',
    Sales = 'Sales',
}

export enum TxnTypeEnum
{
    APCreditCard = 'APCreditCard',
    ARRefundCreditCard = 'ARRefundCreditCard',
    Bill = 'Bill',
    BillPaymentCheck = 'BillPaymentCheck',
    BuildAssembly = 'BuildAssembly',
    CarryOver = 'CarryOver',
    CashPurchase = 'CashPurchase',
    Charge = 'Charge',
    Check = 'Check',
    CreditCardPayment = 'CreditCardPayment',
    CreditMemo = 'CreditMemo',
    Deposit = 'Deposit',
    EFPLiabilityCheck = 'EFPLiabilityCheck',
    EFTBillPayment = 'EFTBillPayment',
    EFTRefund = 'EFTRefund',
    Estimate = 'Estimate',
    InventoryAdjustment = 'InventoryAdjustment',
    InventoryTransfer = 'InventoryTransfer',
    Invoice = 'Invoice',
    ItemReceipt = 'ItemReceipt',
    JournalEntry = 'JournalEntry',
    LiabilityAdjustment = 'LiabilityAdjustment',
    Paycheck = 'Paycheck',
    PayrollLiabilityCheck = 'PayrollLiabilityCheck',
    PurchaseOrder = 'PurchaseOrder',
    PriorPayment = 'PriorPayment',
    ReceivePayment = 'ReceivePayment',
    RefundCheck = 'RefundCheck',
    ReimburseCharge = 'ReimburseCharge',
    SalesOrder = 'SalesOrder',
    SalesReceipt = 'SalesReceipt',
    SalesTaxPaymentCheck = 'SalesTaxPaymentCheck',
    Transfer = 'Transfer',
    TimeActivity = 'TimeActivity',
    VendorCredit = 'VendorCredit',
    YTDAdjustment = 'YTDAdjustment',
}

export class DepositDistribution
{
    public id: string;
    public lineNum: string;
    public description: string;
    public amount?: number;
    public received?: number;
    public linkedTransactions: LinkedTransaction[];
    public detailType?: LineDetailTypeEnum;
    public account: ReferenceType;
    public checkNumber: string;
    public customer: ReferenceType;
    public class: ReferenceType;
    public paymentMethod: ReferenceType;
    public taxApplicableOn?: TaxApplicableOnEnum;
    public taxCodeRef: ReferenceType;
    public transactionType?: TxnTypeEnum;
    public taxAmount?: number;
    public taxInclusiveAmount?: number;

    public constructor(init?: Partial<DepositDistribution>) { (Object as any).assign(this, init); }
}

export class Deposit
{
    public currency: ReferenceType;
    public department: ReferenceType;
    public depositToAccount: ReferenceType;
    public docNumber: string;
    public exchangeRate?: number;
    public globalTaxCalculation?: GlobalTaxCalculationEnum;
    public homeTotalAmount?: number;
    public id: string;
    public metaData: MetaData;
    public privateNote: string;
    public sparse?: boolean;
    public status?: EntityStatusEnum;
    public syncToken: string;
    public taxFormNumber: string;
    public taxFormType: string;
    public totalAmount?: number;
    public transactionDate?: string;
    public transactionSource: string;
    public transactionStatus: string;
    public transactionTaxDetails: TaxDetails;
    public distributionAmount?: number;
    public distributionTax?: number;
    public distributionTotal?: number;
    public distributions: DepositDistribution[];
    public linkedTransactions: LinkedTransaction[];

    public constructor(init?: Partial<Deposit>) { (Object as any).assign(this, init); }
}

export enum EntityTypeEnum
{
    Customer = 'Customer',
    Employee = 'Employee',
    Job = 'Job',
    Other = 'Other',
    Vendor = 'Vendor',
}

export class EntityReferenceType
{
    public type?: EntityTypeEnum;
    public id: string;
    public value: string;

    public constructor(init?: Partial<EntityReferenceType>) { (Object as any).assign(this, init); }
}

export enum PostingTypeEnum
{
    Credit = 'Credit',
    Debit = 'Debit',
}

export class JournalEntryLine
{
    public id: string;
    public lineNum: string;
    public description: string;
    public amount?: number;
    public received?: number;
    public linkedTransactions: LinkedTransaction[];
    public detailType?: LineDetailTypeEnum;
    public class: ReferenceType;
    public account: ReferenceType;
    public entity: EntityReferenceType;
    public billableStatus?: BillableStatusEnum;
    public postingType?: PostingTypeEnum;
    public taxApplicableOn?: TaxApplicableOnEnum;
    public taxAmount?: number;
    public taxCodeRef: ReferenceType;
    public taxInclusiveAmount?: number;

    public constructor(init?: Partial<JournalEntryLine>) { (Object as any).assign(this, init); }
}

export class JournalEntry
{
    public adjustment?: boolean;
    public currency: ReferenceType;
    public department: ReferenceType;
    public docNumber: string;
    public enteredInHomeCurrency?: boolean;
    public exchangeRate?: number;
    public globalTaxCalculation?: GlobalTaxCalculationEnum;
    public homeCurrencyAdjustment?: boolean;
    public homeTotalAmt?: number;
    public id: string;
    public lines: JournalEntryLine[];
    public metaData: MetaData;
    public privateNote: string;
    public sparse?: boolean;
    public status?: EntityStatusEnum;
    public syncToken: string;
    public taxFormNumber: string;
    public taxFormType: string;
    public totalAmount?: number;
    public transactionDate?: string;
    public transactionSource: string;
    public transactionStatus: string;
    public transactionTaxDetails: TaxDetails;
    public lineCreditAmount?: number;
    public lineDebitAmount?: number;
    public lineAmount?: number;
    public lineCreditTax?: number;
    public lineDebitTax?: number;
    public lineTax?: number;
    public lineCreditTotal?: number;
    public lineDebitTotal?: number;
    public lineTotal?: number;
    public linkedTransactions: LinkedTransaction[];

    public constructor(init?: Partial<JournalEntry>) { (Object as any).assign(this, init); }
}

export class ImportFile
{
    public type?: FileType;
    public filename: string;
    public bills: Bill[];
    public billAttachments: Attachment[][];
    public expenses: Expense[];
    public expenseAttachments: Attachment[][];
    public salesReceipts: SalesReceipt[];
    public salesReceiptAttachments: Attachment[][];
    public deposits: Deposit[];
    public depositAttachments: Attachment[][];
    public journalEntries: JournalEntry[];
    public journalEntryAttachments: Attachment[][];
    public billAmount?: number;
    public billTax?: number;
    public billTotal?: number;
    public expenseAmount?: number;
    public expenseTax?: number;
    public expenseTotal?: number;
    public salesReceiptAmount?: number;
    public salesReceiptTax?: number;
    public salesReceiptTotal?: number;
    public depositAmount?: number;
    public depositTax?: number;
    public depositTotal?: number;
    public journalEntryAmount?: number;
    public journalEntryTax?: number;
    public journalEntryTotal?: number;

    public constructor(init?: Partial<ImportFile>) { (Object as any).assign(this, init); }
}

export class Attachment
{
    public name: string;
    public url: string;
    public guid: string;
    public type: string;

    public constructor(init?: Partial<Attachment>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class ImportError
{
    public code: string;
    public message: string;
    public element: string;
    public detail: string;

    public constructor(init?: Partial<ImportError>) { (Object as any).assign(this, init); }
}

export class ImportException
{
    public code: string;
    public message: string;
    public source: string;
    public innerExceptions: ImportError[];

    public constructor(init?: Partial<ImportException>) { (Object as any).assign(this, init); }
}

export class ImportResponse
{
    public success: boolean;
    public id: string;
    public exception: ImportException;

    public constructor(init?: Partial<ImportResponse>) { (Object as any).assign(this, init); }
}

export class UploadFileResponse
{
    public responseStatus: ResponseStatus;
    public files: ImportFile[];

    public constructor(init?: Partial<UploadFileResponse>) { (Object as any).assign(this, init); }
}

export class ImportFileToQuickbooksResponse
{
    public responseStatus: ResponseStatus;
    public billImportResponses: ImportResponse[];
    public expenseImportResponses: ImportResponse[];
    public salesReceiptImportResponses: ImportResponse[];
    public depositImportResponses: ImportResponse[];
    public jounralEntryResponses: ImportResponse[];

    public constructor(init?: Partial<ImportFileToQuickbooksResponse>) { (Object as any).assign(this, init); }
}

export class ImportAttachmentResponse
{
    public responseStatus: ResponseStatus;
    public attachment: Attachment;

    public constructor(init?: Partial<ImportAttachmentResponse>) { (Object as any).assign(this, init); }
}

export class UploadAttachmentResponse
{
    public responseStatus: ResponseStatus;
    public attachment: Attachment;

    public constructor(init?: Partial<UploadAttachmentResponse>) { (Object as any).assign(this, init); }
}

export class HelloResponse
{
    public result: string;

    public constructor(init?: Partial<HelloResponse>) { (Object as any).assign(this, init); }
}

export class TestLoginResponse
{

    public constructor(init?: Partial<TestLoginResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

export class UploadFile implements IReturn<UploadFileResponse>
{

    public constructor(init?: Partial<UploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadFileResponse(); }
}

export class ImportFileToQuickbooks implements IReturn<ImportFileToQuickbooksResponse>
{
    public file: ImportFile;

    public constructor(init?: Partial<ImportFileToQuickbooks>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImportFileToQuickbooks'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImportFileToQuickbooksResponse(); }
}

export class ImportAttachment implements IReturn<ImportAttachmentResponse>
{
    public attachment: Attachment;
    public entityType: string;
    public entityId: string;

    public constructor(init?: Partial<ImportAttachment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImportAttachment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImportAttachmentResponse(); }
}

// @Route("/attachment/{Guid}", "GET")
export class GetUploadedAttachment
{
    public guid: string;

    public constructor(init?: Partial<GetUploadedAttachment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadedAttachment'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class UploadAttachment implements IReturn<UploadAttachmentResponse>
{
    public attachment: Attachment;

    public constructor(init?: Partial<UploadAttachment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadAttachment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadAttachmentResponse(); }
}

// @Route("/hello")
// @Route("/hello/{Name}")
export class Hello implements IReturn<HelloResponse>
{
    public name: string;

    public constructor(init?: Partial<Hello>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Hello'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HelloResponse(); }
}

// @Route("/login-test", "GET")
export class TestLogin implements IReturn<TestLoginResponse>
{

    public constructor(init?: Partial<TestLogin>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TestLogin'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TestLoginResponse(); }
}

/**
* Sign In
*/
// @Route("/auth", "OPTIONS,GET,POST,DELETE")
// @Route("/auth/{provider}", "OPTIONS,GET,POST,DELETE")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /**
    * AuthProvider, e.g. credentials
    */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}




// WEBPACK FOOTER //
// ./src/api/dtos.ts